var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "faqq__category" }, [
    _c("h3", { class: _vm.category.slug }, [_vm._v(_vm._s(_vm.category.name))]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.questions, function (question) {
        return _c("faq-question", {
          key: question.ID,
          attrs: {
            active:
              _vm.activeQuestion === question.ID &&
              _vm.activeCategory === _vm.id,
            category: _vm.id,
            question: question,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FaqCategory.vue